import React from "react";

import { Route, Routes } from "react-router-dom";

import Login from "./features/auth";
import SidebarLayout from "./features/side-bar/SidebarLayout";
import PrivateRoute from "./features/routes/PrivateRoute";
import PublicRoute from "./features/routes/PublicRoute";
import Blog from "./features/blog/Blog";
import NewsLink from "./features/newsLink/NewsLink";
import Blogdetail from "./features/blog/Blogdetail";
import CreateForm from "./features/blog/CreateForm";
// import DeleteModal from "./features/Common/DeleteModal";
import Linkdetail from "./features/newsLink/Linkdetail";
import Createlink from "./features/newsLink/Createlink";
import "./App.css";
import Deletelink from "./features/newsLink/Deletelink";
import Contactpage from "./features/ContactUs/Contactpage";
import GetJobs from "./features/Jobs/GetJobs";
import StoreLocattion from "./features/store-locations/StoreLocattion";
import EditStorePage from "./features/store-locations/components/EditStorePage";
import BannerBlogAccordion from "./features/blog/accordians/BannerListing";
import CreateBanner from "./features/blog/accordians/CreateBanner";
import BannerListing from "./features/blog/accordians/BannerListing";
import BannerDetail from "./features/blog/accordians/BannerDetail";
import CategoryList from "./features/FaqCategory/components/CategoryList";
import AddCategory from "./features/FaqCategory/components/AddCategory";
import EditCategory from "./features/FaqCategory/components/EditCategory";
import TestimonailList from "./features/Testimonial/components/TestimonailList";
import PerformanceReport from "./features/performance-report/PerformanceReport";
import LoginHR from "./features/hr-container/login/LoginHR";
import CandidateListing from "./features/hr-container/candidate/CandidateListing";
import JobListing from "./features/hr-container/job/JobListing";
import CandidateDetail from "./features/hr-container/candidate/CandidateDetail";
import JobDetail from "./features/hr-container/job/JobDetail";
import JobsFormData from "./features/hr-container/jobFormData/jobFormDataList";
import EditJobForm from "./features/hr-container/jobFormData/EditJobForm";
import NewJobForm from "./features/hr-container/jobFormData/NewJobForm";
import BuyNow from "./features/BuyNow/BuyNow";
import EvoBookings from "./features/EvoBookings/EvoBookings";
import Sitemap from "./features/Sitemap/Sitemap";
import VasPurchase from "./features/VasPurchase/VasPurchase";
import PreBookings from "./features/PreBookings/PreBookings";

import EventLead from "./features/event-lead/EventLead";
import DealershipLead from "./features/dealership-lead/DealershipLead";
import MetaTagList from "./features/MetaTagsAndSeo/MetaTagList";
import AddApplicationCategory from "./features/MetaTagsAndSeo/AddMetaTags";
import BookingLocations from "./features/BookingDynamicRoute/createdynamicroute";
import DynamicRouteList from "./features/BookingDynamicRoute/dynamicroutelist";
import { ToastContainer } from "react-toastify";
import BannerText from "./features/PageCategoryDetails/bannerText";
import CategoryDetails from "./features/PageCategoryDetails/categoryDetails";
import AnnouncementTicker from "./features/AnnounceMentTicker/ticker";
import OfferPageData from "./features/OfferPage/offerpagedata";
import CorporateEnquiry from "./features/corporate-enquiry/CorporateEnquiry";
import ScrollToTop from "./features/Common/ScrollToTop";
import VehiclePricing from "./features/VehiclePricing/VehiclePricing";
import RedirectsPage from "./features/RedirectsPage/RedirectsPage";
import ChildSitemap from "./features/ChildSitemap/ChildSitemap";

// import BookingLocations from "./features/bookingLocations/locationsbooking";

// import EventLead from "./features/event-lead/EventLead";

function App() {
  console.log("Testing App.js file");
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route element={<SidebarLayout />}>
          <Route
            path="/dashboard/blog"
            element={
              <PrivateRoute slug="Blog">
                <Blog />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/banner"
            element={
              <PrivateRoute slug="Blog">
                <BannerListing />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/newslink"
            element={
              <PrivateRoute slug="Press">
                <NewsLink />
              </PrivateRoute>
            }
          />
          <Route
            bannerdetail
            path="/dashboard/blogdetail"
            element={
              <PrivateRoute slug="Blog">
                <Blogdetail />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/bannerdetail"
            element={
              <PrivateRoute slug="Blog">
                <BannerDetail />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/linkdetail"
            element={
              <PrivateRoute slug="Press">
                <Linkdetail />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/create/blog"
            element={
              <PrivateRoute slug="Blog">
                <CreateForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/create/banner"
            element={
              <PrivateRoute slug="Blog">
                <CreateBanner />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/create/link"
            element={
              <PrivateRoute slug="Press">
                <Createlink />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/contact-us"
            element={
              <PrivateRoute slug="Contact">
                <Contactpage />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/jobs"
            element={
              <PrivateRoute slug="Jobs">
                <GetJobs />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/store-location"
            element={
              <PrivateRoute slug="Store Locations">
                <StoreLocattion />
              </PrivateRoute>
            }
          />
          {["/dashboard/editStore", "/dashboard/editStore/:id"].map((path) => (
            <Route
              key={path}
              path={path}
              element={
                <PrivateRoute slug="Store Locations">
                  <EditStorePage />
                </PrivateRoute>
              }
            />
          ))}

          <Route
            path="/dashboard/delete/link"
            element={
              <PrivateRoute slug="Press">
                <Deletelink />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/faq/category-list"
            element={
              <PrivateRoute slug="FAQs">
                <CategoryList />
              </PrivateRoute>
            }
          />

          <Route
            path="/dashboard/metatags/application-category"
            element={
              <PrivateRoute slug="MetatagsandSEO">
                <AddApplicationCategory />
              </PrivateRoute>
            }
          />

          <Route
            path="/dashboard/category/category-list-application"
            element={
              <PrivateRoute slug="MetatagsandSEO">
                {/* <p>Meta Tags and SEO Content</p> */}
                <MetaTagList />
              </PrivateRoute>
            }
          />

          <Route
            path="/dashboard/announcement-ticker"
            element={
              <PrivateRoute slug="Announcement Ticker">
                <AnnouncementTicker />
              </PrivateRoute>
            }
          />

          <Route
            path="/dashboard/Offers-page-data"
            element={
              <PrivateRoute slug="Offers Page Data">
                {/* <AnnouncementTicker /> */}
                <OfferPageData />
              </PrivateRoute>
            }
          />

          <Route
            path="/dashboard/bookinglocation/dynamic-location-routes"
            element={
              <PrivateRoute slug="Dynamic Booking Location Routes">
                <DynamicRouteList />
              </PrivateRoute>
            }
          />

          <Route
            path="/dashboard/bookinglocation/add-dynamic-location-routes"
            element={
              <PrivateRoute slug="Dynamic Booking Location Routes">
                <BookingLocations />
              </PrivateRoute>
            }
          />

          <Route
            path="/dashboard/PageCategoryDetails/page-category-details"
            element={
              <PrivateRoute slug="Product Page Banner Video & Details">
                <BannerText />
              </PrivateRoute>
            }
          />

          {[
            "/dashboard/PageCategoryDetails",
            "/dashboard/PageCategoryDetails/:id",
          ].map((path) => (
            <Route
              key={path}
              path={path}
              element={
                <PrivateRoute slug="Product Page Banner Video & Details">
                  <CategoryDetails />
                </PrivateRoute>
              }
            />
          ))}

          <Route
            path="/dashboard/faq/category-add"
            element={
              <PrivateRoute slug="FAQs">
                <AddCategory />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/faq/category-edit/:id"
            element={
              <PrivateRoute slug="FAQs">
                <EditCategory />
              </PrivateRoute>
            }
          />

          <Route
            path="/dashboard/faq/category-edit/:id"
            element={
              <PrivateRoute slug="FAQs">
                <EditCategory />
              </PrivateRoute>
            }
          />

          <Route
            path="/dashboard/testimonial-list"
            element={
              <PrivateRoute slug="Campaign Review">
                <TestimonailList />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/form"
            element={
              // <PrivateRoute slug="Form Review">
              <JobsFormData />
              // </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/form/edit"
            element={
              // <PrivateRoute slug="Form Review">
              <EditJobForm />
              // <JobsFormData />
            }
          />
          <Route
            path="/dashboard/form/create"
            element={
              // <PrivateRoute slug="Form Review">
              <NewJobForm />
              // <JobsFormData />
            }
          />
          <Route
            path="/dashboard/interim-storage"
            element={
              <PrivateRoute slug="Interim Storage">
                <PerformanceReport />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/event-lead"
            element={
              <PrivateRoute slug="Dussehra Campaign">
                <EventLead />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/corporate-enquiry"
            element={
              <PrivateRoute slug="Corporate Enquiry">
                <CorporateEnquiry />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/dealership-lead"
            element={
              <PrivateRoute slug="Dealership Leads">
                <DealershipLead />
              </PrivateRoute>
            }
          />
          {/* hr login code */}
          <Route
            path="/hr-portal/candidate-listing"
            element={
              <PrivateRoute slug="Candidate Listing">
                <CandidateListing />
              </PrivateRoute>
            }
          />
          <Route
            path="/hr-portal/candidate-detail/:id"
            element={
              <PrivateRoute slug="Candidate Listing">
                <CandidateDetail />
              </PrivateRoute>
            }
          />
          <Route
            path="/hr-portal/job-listing"
            element={
              <PrivateRoute slug="Job Listing">
                <JobListing />
              </PrivateRoute>
            }
          />

          <Route
            path="/hr-portal/job-detail/:id"
            element={
              <PrivateRoute slug="Job Listing">
                <JobDetail />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/buy-now"
            element={
              <PrivateRoute slug="Buy Now">
                <BuyNow />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/vehicle-pricing"
            element={
              <PrivateRoute slug="Vehicle Pricing">
                <VehiclePricing />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/evo-bookings"
            element={
              <PrivateRoute slug="Evo Bookings">
                <EvoBookings />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/redirects"
            element={
              <PrivateRoute slug="URL Redirects">
                <RedirectsPage />
              </PrivateRoute>
            }
          />


          <Route
            path="/dashboard/sitemap"
            element={
              // <PrivateRoute slug="Sitemap">
              <Sitemap />
              // </PrivateRoute>
            }
          />
          <Route path="/sitemaps/child" element={<ChildSitemap />} />
          <Route
            path="/dashboard/vas-purchase"
            element={
              <PrivateRoute slug="Vas Purchase">
                <VasPurchase />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard/pre-bookings"
            element={
              <PrivateRoute slug="Pre Bookings">
                <PreBookings />
              </PrivateRoute>
            }
          />
        </Route>


        <Route path="/hr-portal" element={<LoginHR />} />

        {/* hr login code */}

        <Route
          exact
          path="/"
          element={
            // <PublicRoute>
            <Login />
            // </PublicRoute>
          }
        />
      </Routes>
      <ToastContainer />
    </>
  );
}

export default App;
